import { AxiosError } from 'axios'
import { useQuery, UseQueryOptions } from 'react-query'
import { removeEmptyFieldObject, useLocale } from '@plandi/common'

import { projectKeys } from '../projects.constants'
import { projectsApi } from '../projects.api'
import {
  ProjectsProfile,
  ProjectsUser,
  QueryParamsProjectsByUserId
} from '../projects.types'

export const useQueryProjectsByUserId = <T = ProjectsUser | undefined>(
  userId?: number,
  params?: QueryParamsProjectsByUserId,
  options?: UseQueryOptions<ProjectsUser | undefined, AxiosError, T>
) => {
  const paramsOptions = removeEmptyFieldObject(params ?? {})
  const locale = useLocale()

  return useQuery(
    [projectKeys.user(userId as number, paramsOptions), locale],
    () => {
      if (userId) {
        return projectsApi.getProjectsByUserId(userId, locale, paramsOptions)
      }
    },
    options
  )
}

export const useQueryProjectsByProfileId = <T = ProjectsProfile | undefined>(
  type: string,
  userId?: number,
  params?: QueryParamsProjectsByUserId,
  options?: UseQueryOptions<ProjectsProfile | undefined, AxiosError, T>
) => {
  const paramsOptions = removeEmptyFieldObject(params ?? {})
  const locale = useLocale()

  return useQuery(
    [projectKeys.user(userId as number, paramsOptions), locale],
    () => {
      if (userId) {
        return projectsApi.getProjectsByProfileId(
          type,
          userId,
          locale,
          paramsOptions
        )
      }
    },
    options
  )
}
